import { Scope, defaultCCItemProperties } from '../../shared';

export const attributedTransactions = {
  id: 'attributed-transactions',
  name: _TL_('Attributed transactions'),
  oldUIScope: [Scope.Account],
  children: [
    {
      ...defaultCCItemProperties,
      id: 'attributed-transactions',
      name: _TL_('Attributed transactions'),
      route: 'Billing/CashbackApproval',
      scope: [Scope.Account],
      checkPermission: permissions => permissions.dynamic.PersonalizedOffers
        || permissions.dynamic.PersonalizedOffersV2
        || permissions.dynamic.PersonalizedOffersV3,
    },
  ],
};
